import FormPage from "@/components/FormPage";
import { api, IMAGES } from "@/lib/api";

export default function Register() {
    return (
        <FormPage
            testIdPrefix="register"
            eyebrow="For Caregivers"
            title="Register Now"
            tagline="we've got you"
            description="Join our community of kinship caregivers. Get access to resources, events, and a network of people who understand your journey."
            heroImage={IMAGES.hawkins}
            accentColor="purple"
            fields={[
                { name: "name", label: "Full Name", required: true, placeholder: "Your name" },
                { name: "email", label: "Email", type: "email", required: true, placeholder: "you@example.com" },
                { name: "phone", label: "Phone", placeholder: "(optional)" },
                { name: "children_count", label: "How many children in your care?", type: "number", placeholder: "0" },
                { name: "family_details", label: "Tell us about your family", type: "textarea", placeholder: "Anything you'd like us to know..." },
            ]}
            submitLabel="Register"
            onSubmit={(v) => api.post("/register", { ...v, children_count: parseInt(v.children_count || 0, 10) })}
            successTitle="Welcome to the village 🤍"
            successMessage="We received your registration. Someone from our team will reach out within 48 hours."
        />
    );
}
